/* import __COLOCATED_TEMPLATE__ from './new-version-notifier.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
let NewVersionNotifier = (_class = class NewVersionNotifier extends Component {
  constructor(...args) {
    super(...args);
    /** @type {import("ember-cli-new-version/services/new-version").default} */
    _initializerDefineProperty(this, "newVersion", _descriptor, this);
    _initializerDefineProperty(this, "updateMessage", _descriptor2, this);
    _initializerDefineProperty(this, "showReload", _descriptor3, this);
    _initializerDefineProperty(this, "reloadButtonText", _descriptor4, this);
  }
  /**
   * @returns {string | undefined}
   */
  get message() {
    if (this.newVersion.isNewVersionAvailable) {
      return this.updateMessage.replace('{oldVersion}', this.newVersion.currentVersion).replace('{newVersion}', this.newVersion.latestVersion);
    }
    return undefined;
  }
  close(event) {
    event.preventDefault();
    this.newVersion.ignoreVersion(this.newVersion.latestVersion);
    return false;
  }
  reload(event) {
    event.preventDefault();
    if (typeof window !== 'undefined' && window.location) {
      window.location.reload(true);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "newVersion", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "updateMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.updateMessage ?? 'This application has been updated from version {oldVersion} to {newVersion}. Please save any work, then refresh browser to see changes.';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showReload", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.showReload ?? true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "reloadButtonText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.reloadButtonText ?? 'Reload';
  }
}), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reload", [action], Object.getOwnPropertyDescriptor(_class.prototype, "reload"), _class.prototype), _class);
export { NewVersionNotifier as default };